import type { PrivateArtnightParams, PrivateArtnightReturn } from '../types';
import { formatUSPCardTextContent } from '../helpers';

export default function (params: PrivateArtnightParams): PrivateArtnightReturn {
  const {
    component,
    _editable,
    _uid,
    image,
    title,
    subTitle,
    cta,
    textContentPositionMobile,
    textContentPositionTablet,
    textContentPositionDesktop,
    alignItems
  } = params;

  return {
    component,
    _editable,
    _uid,
    module: 'SPrivateArtnight',
    image: image?.[0],
    title: formatUSPCardTextContent(title?.[0]),
    subTitle: formatUSPCardTextContent(subTitle?.[0]),
    cta,
    textContentPositionMobile,
    textContentPositionTablet,
    textContentPositionDesktop,
    alignItems
  };
}
